import { useContext } from 'react';
import { toString } from 'lodash';
import { CustomSelect } from 'components';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { financialStatementPeriodsListStyles } from './gpc/config/GPCLists.styles';
import { FinancialStatementPeriodsProps } from './types';

const FinancialStatementPeriods = ({ cell, options, ...restProps }: FinancialStatementPeriodsProps) => {
  const { onCommit, onRevert } = restProps;
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const handleChange = (value: string | null) => {
    const newValue = toString(value);
    onCellsChanged([{ cell, value: newValue }]);
  };

  return (
    <CustomSelect
      disabled={cell.readOnly}
      extraStyles={financialStatementPeriodsListStyles}
      id={`financial-statement-periods-${cell.key}`}
      onChange={handleChange}
      onCommit={onCommit}
      onEmptyValue=""
      onRevert={onRevert}
      options={options}
      value={cell.value as string}
    />
  );
};

export default FinancialStatementPeriods;
